/* =========================================================
   ALUNEA - sticky kopknapp

   Bade temats egen logik och var forra version avgjorde synlighet
   utifran .buy-buttons-block. Det blocket doljs med display:none av
   bundelvaljaren, och ett dolt element har alltid rect.bottom = 0 -
   villkoret "har kunden skrollat forbi kopknappen?" blev darfor aldrig
   sant och baren visades aldrig. Vi utgar fran sjalva bundelvaljaren.

   Baren delar formular med bundelvaljaren. Darfor haller vi det dolda
   variant-faltet i synk med valt kort - annars lagger barens knapp till
   Singel aven nar kunden valt Presentbundle.

   Ingen requestAnimationFrame: den pausas i bakgrundsflikar och baren
   skulle da frysa i fel lage.
   ========================================================= */
(function () {
  if (window.__aluneaStickyBar) return;
  window.__aluneaStickyBar = true;

  var bar = null;
  var anchor = null;
  var timer = null;

  function valtKort() {
    return document.querySelector('.ab-card.is-selected');
  }

  /* Byter ut pristexten men behaller det dolda skarmlasar-prefixet. */
  function satPris(el, text) {
    if (!el) return;
    var dolt = el.querySelector('.visually-hidden');
    el.textContent = '';
    if (dolt) el.appendChild(dolt);
    if (text) el.appendChild(document.createTextNode(' ' + text));
  }

  function synka() {
    var kort = valtKort();
    if (!kort || !bar) return;

    var input = document.querySelector('product-form-component form input[name="id"]');
    var id = kort.getAttribute('data-variant-id');
    if (input && id && input.value !== id) {
      input.value = id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var nu = kort.querySelector('.ab-card__now');
    var fore = kort.querySelector('.ab-card__was');
    satPris(bar.querySelector('.sticky-add-to-cart__price .price'), nu ? nu.textContent.trim() : '');
    satPris(bar.querySelector('.sticky-add-to-cart__price .compare-at-price'), fore ? fore.textContent.trim() : '');

    /* Antalet visas bara for flerpack. "Singel" sager kunden ingenting. */
    var etikett = bar.querySelector('.sticky-add-to-cart__variant');
    if (etikett) {
      var titel = kort.querySelector('.ab-card__title');
      var antal = titel ? parseInt(titel.textContent.trim(), 10) : NaN;
      etikett.textContent = antal > 1 ? antal + ' st' : '';
      etikett.hidden = !(antal > 1);
    }
  }

  function uppdatera() {
    if (!bar || !anchor) return;
    var passerat = anchor.getBoundingClientRect().bottom < 0;
    var kvar = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    var visa = passerat && kvar > 260; /* vik undan over riktiga footern */
    if ((bar.getAttribute('data-stuck') === 'true') !== visa) {
      bar.setAttribute('data-stuck', visa ? 'true' : 'false');
    }
  }

  function schemalagg() {
    uppdatera();                          /* direkt respons under scroll */
    clearTimeout(timer);
    timer = setTimeout(uppdatera, 80);    /* fanga slutlaget efter momentum */
  }

  function init() {
    bar = document.querySelector('.sticky-add-to-cart__bar');
    anchor = document.querySelector('.alunea-bundle') || document.querySelector('.buy-buttons-block');
    if (!bar || !anchor) return;

    /* Temat slar tillbaka attributet nar dess observer triggar - satt om det */
    new MutationObserver(uppdatera).observe(bar, {
      attributes: true,
      attributeFilter: ['data-stuck']
    });

    document.addEventListener('click', function (event) {
      var traff = event.target && event.target.closest && event.target.closest('.ab-card');
      if (traff) setTimeout(synka, 0); /* vanta in bundelns egen is-selected */
    });

    window.addEventListener('scroll', schemalagg, { passive: true });
    window.addEventListener('resize', schemalagg, { passive: true });

    synka();
    uppdatera();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
